'use strict';

export default {
  nestedItem: Symbol('Nested Item')
};



/** WEBPACK FOOTER **
 ** ./src/itemTypes.js
 **/